import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@verlo/shared/components/ui/sonner";
import { AuthProvider } from "@verlo/shared/contexts/AuthContext";
import { AppProvider } from "@verlo/shared/contexts/AppContext";
import ErrorBoundary from "@verlo/shared/components/common/ErrorBoundary";
import { useVersionWatch } from "@verlo/shared/hooks/useVersionWatch";
import { tillIsBusy } from "./lib/reloadSafety";
import nodeRoutes from "./routes/nodeRoutes";
import NotFound from '@verlo/shared/components/NotFound';

// node-ui — the kiosk on the Pi (P7, plan §6). The old single tree chose its router by the
// `@surface-routes` webpack alias; a workspace makes the surface the *package*, so the FOH
// route tree is simply imported here. There is no `/login` — node-api mounts no
// `POST /auth/login` — so `/` lands on `/tables`, and a signed-out kiosk is sent to `/kiosk` by
// the guards. An address that isn't a page says so (Chris's review M13).
function App() {
  // A till is loaded once and left on for weeks, so it cannot wait for someone to reload it
  // to pick up a release. nginx keeps the shell uncached, which covers every *load*; this
  // covers the tab that never gets one (Oct 2026).
  //
  // `tillIsBusy` is node-ui's veto on reloading without being asked: a dialog someone is
  // working in, and the kitchen and bar boards, which lose their chime to a reload that has
  // no user gesture behind it. Those get the toast instead.
  useVersionWatch({ busy: tillIsBusy });

  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <AppProvider>
              <Routes>
                {nodeRoutes()}
                <Route path="/" element={<Navigate to="/tables" replace />} />
                <Route path="*" element={<NotFound home="/tables" homeLabel="Back to Tables" />} />
              </Routes>
              {/* Bottom-left, not bottom-centre: at the till's width the centre is where the order pad's
                  Take payment / Send button sits, and a toast must never cover the thing it's about. */}
              <Toaster position="bottom-left" />
            </AppProvider>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
